var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2829 44H10V4H38V33.1667C38 33.6275 37.6319 34 37.1765 34C36.7211 34 36.3529 33.6275 36.3529 33.1667V5.66667H11.6471V42.3333H28.6011L34.948 35.9108C35.27 35.585 35.7905 35.585 36.1125 35.9108C36.4345 36.2367 36.4345 36.7633 36.1125 37.0892L29.2829 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1175 40.6666C27.6621 40.6666 27.2939 40.2941 27.2939 39.8333V32.3333H37.1763C37.6317 32.3333 37.9998 32.7058 37.9998 33.1666C37.9998 33.6275 37.6317 34 37.1763 34H28.941V39.8333C28.941 40.2941 28.5729 40.6666 28.1175 40.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2351 10.6667H14.1175C13.6629 10.6667 13.2939 10.2933 13.2939 9.83333C13.2939 9.37333 13.6629 9 14.1175 9H32.2351C32.6905 9 33.0587 9.37333 33.0587 9.83333C33.0587 10.2933 32.6905 10.6667 32.2351 10.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2351 15.6667H14.1175C13.6629 15.6667 13.2939 15.2933 13.2939 14.8333C13.2939 14.3733 13.6629 14 14.1175 14H32.2351C32.6905 14 33.0587 14.3733 33.0587 14.8333C33.0587 15.2933 32.6905 15.6667 32.2351 15.6667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2939 20.6667H14.1175C13.6629 20.6667 13.2939 20.2933 13.2939 19.8333C13.2939 19.3733 13.6629 19 14.1175 19H27.2939C27.7494 19 28.1175 19.3733 28.1175 19.8333C28.1175 20.2933 27.7494 20.6667 27.2939 20.6667Z",
    fill: "#DC0032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5881 25.6667H14.1175C13.6629 25.6667 13.2939 25.2942 13.2939 24.8333C13.2939 24.3733 13.6629 24 14.1175 24H30.5881C31.0435 24 31.4116 24.3733 31.4116 24.8333C31.4116 25.2942 31.0435 25.6667 30.5881 25.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentForm);
export default __webpack_public_path__ + "static/media/iconDocumentForm.36014e427cde34cc876a64d0b4be3610.svg";
export { ForwardRef as ReactComponent };